module.exports = __webpack_public_path__ + "img/performance-no-data.24414e3a.png";